import { type TaskId } from "@tento-lona/sheets";
export namespace DragTaskState {
  export let taskId: Option<TaskId> = null;

  export function start(id: TaskId): void {
    taskId = id;
  }

  export function end(): void {
    taskId = null;
  }

  export function isDragging(): boolean {
    return taskId != null;
  }
}
